
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homes/[state]/[market]",
      function () {
        return require("private-next-pages/homes/[state]/[market].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homes/[state]/[market]"])
      });
    }
  